export function emptyTemplate(editionId: string) {
    return {
        page: {
            body: {
                container: {style: {'background-color': '#FFFFFF'}},
                content: {
                    computedStyle: {
                        linkColor: '#007089',
                        messageBackgroundColor: 'transparent',
                        messageWidth: '675px',
                    },
                    style: {
                        color: '#000000',
                        'font-family': 'Arial, Helvetica Neue, Helvetica, sans-serif',
                    },
                },
                type: 'mailup-bee-page-properties',
                webFonts: [
                    {
                        fontFamily:
                            "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                        name: 'Montserrat',
                        url: 'https://fonts.googleapis.com/css?family=Montserrat',
                    },
                    {
                        fontFamily: "'IBM Plex Sans', Trebuchet MS, sans-serif",
                        name: 'IBM Plex Sans',
                        url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap',
                    },
                    {
                        fontFamily: "'Source Sans Pro', Trebuchet MS, sans-serif",
                        name: 'Source Sans Pro',
                        url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap',
                    },
                ],
            },
            description: 'BF-ecommerce-template',
            rows: [
                {
                    container: {
                        style: {
                            'background-color': 'transparent',
                            'background-image': 'none',
                            'background-repeat': 'no-repeat',
                            'background-position': 'top left',
                        },
                    },
                    content: {
                        style: {
                            'background-color': 'transparent',
                            color: '#000000',
                            width: '500px',
                            'background-image': 'none',
                            'background-repeat': 'no-repeat',
                            'background-position': 'top left',
                        },
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                    },
                    columns: [
                        {
                            style: {
                                'background-color': 'transparent',
                                'border-bottom': '0px solid transparent',
                                'border-left': '0px solid transparent',
                                'border-right': '0px solid transparent',
                                'border-top': '0px solid transparent',
                                'padding-bottom': '5px',
                                'padding-left': '0px',
                                'padding-right': '0px',
                                'padding-top': '5px',
                            },
                            modules: [
                                {
                                    type: 'mailup-bee-newsletter-modules-text',
                                    descriptor: {
                                        text: {
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 16px; line-height: 28px;"><p style=\'font-size: 16px;\'>This is a text block. Type something here to get started.</p></div>',
                                            style: {
                                                color: '#555555',
                                                'line-height': '150%',
                                                'font-family':
                                                    "'Source Sans Pro', Trebuchet MS, sans-serif",
                                            },
                                            computedStyle: {linkColor: '#007089'},
                                        },
                                        style: {
                                            'padding-top': '10px',
                                            'padding-right': '10px',
                                            'padding-bottom': '10px',
                                            'padding-left': '10px',
                                        },
                                        computedStyle: {hideContentOnMobile: false},
                                    },
                                    uuid: '5a24f096-61ca-42b4-af0d-f2895a6e1252',
                                },
                            ],
                            'grid-columns': 12,
                            uuid: '753c1a06-ae20-456a-b228-84ffd17ec10b',
                        },
                    ],
                    type: 'one-column-empty',
                    uuid: 'bd05a6ef-e436-4300-8f9e-9a0fd76e6bb1',
                },
                {
                    columns: [
                        {
                            'grid-columns': 12,
                            modules: [],
                            style: {
                                'background-color': 'transparent',
                                'border-bottom': '0px solid transparent',
                                'border-left': '0px solid transparent',
                                'border-right': '0px solid transparent',
                                'border-top': '0px solid transparent',
                                'padding-bottom': '5px',
                                'padding-left': '0px',
                                'padding-right': '0px',
                                'padding-top': '5px',
                            },
                            uuid: 'f73a149a-623c-4438-81ce-d242b220b46a',
                        },
                    ],
                    container: {
                        style: {
                            'background-color': 'transparent',
                            'background-image': 'none',
                            'background-position': 'top left',
                            'background-repeat': 'no-repeat',
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            'background-color': 'transparent',
                            'background-image': 'none',
                            'background-position': 'top left',
                            'background-repeat': 'no-repeat',
                            color: '#000000',
                            width: '500px',
                        },
                    },
                    type: 'one-column-empty',
                    uuid: 'ba679ded-7035-4ae0-afe1-96be651d1ad7',
                },
                {
                    columns: [
                        {
                            'grid-columns': 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: 'center',
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                'border-top': '1px solid #BBBBBB',
                                                width: '100%',
                                            },
                                        },
                                        style: {
                                            'padding-bottom': '10px',
                                            'padding-left': '10px',
                                            'padding-right': '10px',
                                            'padding-top': '10px',
                                        },
                                    },
                                    type: 'mailup-bee-newsletter-modules-divider',
                                    uuid: 'd60d55d6-86a4-48d8-b772-709ab315b940',
                                },
                                {
                                    descriptor: {
                                        computedStyle: {hideContentOnMobile: false},
                                        style: {
                                            'padding-bottom': '10px',
                                            'padding-left': '10px',
                                            'padding-right': '10px',
                                            'padding-top': '10px',
                                        },
                                        text: {
                                            computedStyle: {linkColor: '#007089'},
                                            html: `<div class="txtTinyMce-wrapper" style="line-height: 19px; font-size: 16px; font-family: 'Source Sans Pro', 'Trebuchet MS', sans-serif;" data-mce-style="line-height: 19px; font-size: 16px; font-family: 'Source Sans Pro', 'Trebuchet MS', sans-serif;"><p style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center; font-family: 'Source Sans Pro', 'Trebuchet MS', sans-serif;" data-mce-style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;"><span style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><code data-bee-code="">{mailingAddress}</code></span></p><p style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center; font-family: 'Source Sans Pro', 'Trebuchet MS', sans-serif;" data-mce-style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;"><span style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><a style="text-decoration: underline;" href="${location.origin}/unsubscribe/${editionId}" target="_blank" rel="noopener">Unsubscribe / manage preferences</a></span></p></div>`,
                                            style: {
                                                color: '#555555',
                                                'font-family':
                                                    "'Source Sans Pro', Trebuchet MS, sans-serif",
                                                'line-height': '120%',
                                            },
                                        },
                                    },
                                    type: 'mailup-bee-newsletter-modules-text',
                                    uuid: '9a9fe5cc-80e7-419b-80cb-632b407d08f9',
                                },
                            ],
                            style: {
                                'background-color': 'transparent',
                                'border-bottom': '0px solid transparent',
                                'border-left': '0px solid transparent',
                                'border-right': '0px solid transparent',
                                'border-top': '0px solid transparent',
                                'padding-bottom': '5px',
                                'padding-left': '0px',
                                'padding-right': '0px',
                                'padding-top': '5px',
                            },
                            uuid: '2257cf55-5b96-4aa4-8e67-e2d222b82ffc',
                        },
                    ],
                    container: {
                        style: {
                            'background-color': 'transparent',
                            'background-image': 'none',
                            'background-position': 'top left',
                            'background-repeat': 'no-repeat',
                        },
                    },
                    content: {
                        style: {
                            'background-color': 'transparent',
                            'background-image': 'none',
                            'background-position': 'top left',
                            'background-repeat': 'no-repeat',
                            color: '#000000',
                            width: '500px',
                        },
                    },
                    type: 'one-column-empty',
                    uuid: '5084978e-2cb7-4a61-8082-6e1d9c0b2250',
                },
            ],
            template: {name: 'template-base', type: 'basic', version: '2.0.0'},
            title: 'BF-ecommerce-template',
        },
    };
}
